var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.078 .938)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.916 8.024c.31 0 .595-.069.856-.208.262-.138.472-.32.632-.544.16-.224.24-.453.24-.688a.86.86 0 00-.304-.68 1.106 1.106 0 00-.752-.264c-.309 0-.594.072-.856.216-.26.144-.466.331-.616.56-.149.23-.224.462-.224.696 0 .278.096.499.288.664.192.166.438.248.736.248zm2.016 9.504c.14 0 .248-.04.328-.12.08-.08.12-.168.12-.264 0-.117-.029-.202-.088-.256a1.286 1.286 0 00-.28-.176 1.286 1.286 0 01-.464-.344c-.106-.133-.16-.36-.16-.68V10.12c0-.448-.144-.672-.432-.672-.085 0-.21.03-.376.088-.165.059-.46.19-.888.392-.512.235-.86.416-1.048.544-.186.128-.28.267-.28.416 0 .139.038.235.112.288.075.054.192.107.352.16.203.054.36.126.472.216.112.091.168.259.168.504v3.632c0 .32-.053.544-.16.672a1.562 1.562 0 01-.448.352 1.286 1.286 0 00-.28.176c-.058.054-.088.139-.088.256a.37.37 0 00.112.272c.075.075.187.112.336.112l.512-.016c.363-.021.688-.032.976-.032.31 0 .635.011.976.032l.528.016z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 12.461,
    cy: 12.461,
    r: 11.961
  }))));
}
export default SvgInfo;